var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFemale = function SvgFemale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.708 32.477V28.41h-3.775v-2.614h3.775l.029-1.947-.233-.058A8.003 8.003 0 0 1 12 15.918c0-4.416 3.6-8.018 8.014-8.018 1.83 0 3.63.639 5.024 1.801l1.946 2.324C27.65 13.187 28 14.552 28 15.918c0 3.835-2.759 7.146-6.534 7.873l-.232.058-.029 1.946h3.891v2.615h-3.891l.029 4.067h-2.526Zm1.277-22.05c-3.02 0-5.488 2.47-5.488 5.49 0 3.022 2.44 5.52 5.488 5.52 3.05 0 5.488-2.469 5.488-5.52 0-3.05-2.468-5.49-5.488-5.49Z",
    fill: "#fff"
  })));
};
export default SvgFemale;